import React from 'react'
import { SubscriptionPlanEnum } from '@vacationtracker/shared/types/company'
import { PaymentProcessor } from '@vacationtracker/shared/types/billing'
import { Platform } from '@vacationtracker/shared/types/core-event'
import { FeatureFlagEnum } from '@vacationtracker/shared/types/feature-flags'

export interface IRightActionBarItem {
  key: string
  icon: React.ReactNode
  title: string
  tooltip?: string
  badge?: number | string
  roles?: string[]
  platform?: Platform[]
  featureFlag?: FeatureFlagEnum
  plan?: SubscriptionPlanEnum
  paymentProcessors?: PaymentProcessor[]
  onClick?: () => void
  drawerContent?: React.ReactNode
}

export interface IRightActionBarContext {
  // Navbar visibility state
  rightActionBarVisible: boolean
  setRightActionBarVisible: (visible: boolean) => void

  // Active drawer state
  activeDrawer: string | null
  drawerContent: React.ReactNode
  drawerTitle: string
  drawerWidth?: number

  // Drawer actions
  openDrawer: (key: string, title: string, content: React.ReactNode, width?: number) => void
  closeDrawer: () => void

  // Badge management for notifications
  setBadge: (key: string, badge: number | string) => void
  clearBadge: (key: string) => void
  badges: Record<string, number | string>
}

export interface IRightActionBarProvider {
  children: React.ReactNode
}

export enum RightActionBarItemKeys {
  HELP = 'help',
  DOCS = 'docs',
  WHATS_NEW = 'whats-new',
  ANNOUNCEMENTS = 'announcements',
  CHANGELOG = 'changelog',
  ONBOARDING = 'onboarding',
  MS_BOT_SETUP = 'ms-bot-setup'
}
